module.exports = __webpack_public_path__ + "static/media/wordpress-ai-es.193bfbff.png";